import React from 'react';

interface LoadingSpinnerProps {
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className }) => {
  return (
    <svg
      className={`animate-spinner ${className || 'w-12 h-12'}`} // Default size, specific colors applied below
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-label="Loading content"
      role="status"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        className="stroke-primaryGreen opacity-30" // Light green track
        strokeWidth="4"
      ></circle>
      <path
        className="fill-primaryGreen" // Solid primaryGreen for the active spinner segment
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );
};

export default LoadingSpinner;